"use strict";
const _ = require('lodash');
class Invariantor {
    constructor(entity) {
        this.entity = entity;
        this.entity.settings = entity.settings || {};
        this.entity.incomings = entity.incomings || [];
        this.entity.getEndpoints = entity.getEndpoints || [];
        this.entity.outgoings = entity.outgoings || [];
    }
    ensureS3StorageFolder() {
        this.entity.s3StorageFolder = (this.entity.s3StorageFolder ||
            this.entity.name ||
            '').replace(/\s+/g, '-');
        return this;
    }
    ensureIncomingEndpoint() {
        this.entity.incomingEndpoint = _.toLower(this.entity.incomingEndpoint);
        return this;
    }
    ensureCsvDelimiter() {
        this.entity.settings.CSV_DELIMITER = _.get(this.entity, 'settings.CSV_DELIMITER', ',');
        return this;
    }
    ensureCsvNewLineCharacter() {
        this.entity.settings.CSV_NEWLINE = _.get(this.entity, 'settings.CSV_NEWLINE', '\n');
        return this;
    }
    ensureCsvQuote() {
        this.entity.settings.CSV_QUOTE = _.get(this.entity, 'settings.CSV_QUOTE', '"');
        return this;
    }
    ensureCsvColumnToSplitBy() {
        this.entity.settings.CSV_COLUMN_TO_SPLIT_BY = _.get(this.entity, 'settings.CSV_COLUMN_TO_SPLIT_BY', '');
        return this;
    }
    ensureCsvHeaders() {
        this.entity.settings.CSV_HEADERS = _.get(this.entity, 'settings.CSV_HEADERS', []);
        return this;
    }
    ensureCsvSkipLines() {
        this.entity.settings.CSV_SKIP_LINES = _.get(this.entity, 'settings.CSV_SKIP_LINES', 0);
        return this;
    }
    ensureHttpIncomings() {
        this.entity.incomings = this.entity.incomings.map(incoming => {
            if (incoming.incomingChannel === 'HTTP-POST') {
                return { ...incoming, filter: _.toLower(incoming.filter) };
            }
            return incoming;
        });
        return this;
    }
    ensureGetEndpoints() {
        this.entity.getEndpoints = this.entity.getEndpoints.map(getEndpoint => ({
            ...getEndpoint,
            name: _.toLower(getEndpoint.name),
        }));
        return this;
    }
    ensureOrganizationId() {
        if (this.entity.organizationId) {
            this.entity.settings = {
                ...this.entity.settings,
                ORGANIZATION_ID: this.entity.organizationId,
            };
        }
        return this;
    }
    ensureEdifactOutgoings() {
        this.entity.outgoings = this.entity.outgoings.map(outgoing => {
            if (outgoing.writer === 'EDIFACTD96AORDERS' ||
                outgoing.writer === 'PEPPOLBISORDERING32') {
                return { ...outgoing, outputTemplate: '' };
            }
            return outgoing;
        });
        return this;
    }
    ensureOmitPriceOnOrderRow() {
        this.entity.settings.OMIT_PRICE_ON_ORDERROW = _.get(this.entity, 'settings.OMIT_PRICE_ON_ORDERROW', false);
        return this;
    }
    value() {
        return this.entity;
    }
}
module.exports = entity => {
    const ensured = new Invariantor(entity)
        .ensureEdifactOutgoings()
        .ensureOrganizationId()
        .ensureIncomingEndpoint()
        .ensureHttpIncomings()
        .ensureGetEndpoints()
        .ensureOmitPriceOnOrderRow()
        .ensureCsvDelimiter()
        .ensureCsvNewLineCharacter()
        .ensureCsvQuote()
        .ensureCsvSkipLines()
        .ensureCsvColumnToSplitBy()
        .ensureCsvHeaders()
        .ensureS3StorageFolder()
        .value();
    return ensured;
};
